import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { toast, Slide } from 'react-toastify';

import '../assets/sass/style.scss';
import { store, persistor } from '../store';
import setAuthToken from '../utils/setAuthToken';
import AdminContainer from './Admin';
import Modal from '../components/global/Modal';
import history from '../history';
import NotFound from '../pages/NotFound';
import ResetPassword from '../pages/ResetPassword';

if (store.getState().auth && store.getState().auth[process.env.REACT_APP_TOKEN_NAME]) {
  setAuthToken(store.getState().auth[process.env.REACT_APP_TOKEN_NAME]);
}

toast.configure({
  transition: Slide,
  position:   'top-center',
  autoClose:  3000,
});

const AppContainer = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <CssBaseline />
      <Router history={history}>
        <Switch>
          <Route path="/admin/" component={AdminContainer} />
          <Route
            path="/"
            exact
            component={() => (
              <Redirect to={{ pathname: '/admin/login' }} />
            )}
          />
          <Route
            exact
            path="/reset-password/:token"
            component={ResetPassword}
          />
          <Route component={NotFound} />
        </Switch>
        <Modal />
      </Router>
    </PersistGate>
  </Provider>
);

export default AppContainer;
